import { Landmark } from 'lucide-react';
import { formatInstantLagos, formatLagos } from '../../../../utils/datetime';
import { formatCount, formatNaira } from '../../../../utils/money';
import { Card, DetailRow, EmptyState, StatusPill } from '../../../ui';

const OverviewTab = ({ subMerchant }) => {
  const account = subMerchant.bank_account;

  return (
    <div className="grid gap-x-6 lg:grid-cols-2">
      <Card title="Details">
        <DetailRow label="Status" value={<StatusPill status={subMerchant.status} />} />
        <DetailRow label="Contact email" value={subMerchant.email} />
        <DetailRow label="Contact phone" value={subMerchant.phone_number} />
        <DetailRow label="Balance" value={formatNaira(subMerchant.balance)} />
        <DetailRow label="PANs" value={formatCount(subMerchant.pans_count)} />
        <DetailRow label="Users" value={formatCount(subMerchant.users_count)} />
        <DetailRow label="Created (WAT)" value={formatLagos(subMerchant.created_at)} />
      </Card>

      <Card title="Payout account">
        {account?.account_number ? (
          <>
            <DetailRow label="Bank" value={account.bank_name} />
            <DetailRow label="Account number" value={account.account_number} />
            <DetailRow label="Account name" value={account.account_name} />
            <DetailRow label="Verified (WAT)" value={formatInstantLagos(account.bank_account_verified_at)} />
          </>
        ) : (
          <EmptyState
            icon={<Landmark className="h-8 w-8" aria-hidden="true" />}
            title="No payout account"
            message="Not set by the sub-merchant yet. Its users add the account CashCard withdraws to."
          />
        )}
        <p className="mt-3 text-sm text-theme-secondarytextcolor dark:text-themedark-secondarytextcolor">
          Only the sub-merchant&apos;s users can set or change this account.
        </p>
      </Card>
    </div>
  );
};

export default OverviewTab;
